if (!customElements.get('swiper-collection')) {
  customElements.define(
    'swiper-collection',
    class SwiperCollection extends HTMLElement {
      swiperParams = {};

      get swiperEl() {
        return this.querySelector('swiper-container');
      }

      get swiperInstance() {
        return this.swiperEl?.swiper || null;
      }

      get isSwiperReady() {
        return (
          this.swiperEl?.swiper &&
          this.swiperEl.swiper.initialized &&
          !this.swiperEl.swiper.destroyed
        );
      }

      get slidesPerView() {
        return {
          desktop: {
            mediaWidth: Number(this.dataset.mediaWidth) || 990,
            count: Number(this.dataset.slidesPerView) || 1,
            gap: Number(this.dataset.spaceBetween) || 0,
          },
          tablet: {
            mediaWidth: Number(this.dataset.tabletMediaWidth) || 750,
            count: Number(this.dataset.tabletSlidesPerView) || 1,
            gap: Number(this.dataset.tabletSpaceBetween) || 0,
          },
          mobile: {
            mediaWidth: Number(this.dataset.mobileMediaWidth) || 480,
            count: Number(this.dataset.mobileSlidesPerView) || 1,
            gap: Number(this.dataset.mobileSpaceBetween) || 0,
          }
        };
      }

      get navigation() {
        return {
          prev: this.querySelector('[id^="SwiperCollection-Prev"]'),
          next: this.querySelector('[id^="SwiperCollection-Next"]'),
        };
      }

      constructor() {
        super();
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {}

      initSwiper() {
        this.assignSwiperParams();
      }

      assignSwiperParams() {
        if (!this.swiperEl) return;

        const { desktop, tablet, mobile } = this.slidesPerView;
        this.swiperParams.slidesPerView = 1.4;
        this.swiperParams.spaceBetween = mobile.gap == desktop.gap ? desktop.gap : mobile.gap;

        this.swiperParams.breakpoints = {
          [mobile.mediaWidth]: { slidesPerView: mobile.count, spaceBetween: mobile.gap },
          [tablet.mediaWidth]: { slidesPerView: tablet.count, spaceBetween: tablet.gap },
          [desktop.mediaWidth]: { slidesPerView: desktop.count, spaceBetween: desktop.gap },
        };

        if (this.navigation.prev && this.navigation.next) {
          this.swiperParams.navigation = {
            prevEl: this.navigation.prev,
            nextEl: this.navigation.next,
            disabledClass: 'disabled'
          };
        }

        this.swiperInstance?.destroy(true, true),
          Object.assign(this.swiperEl, this.swiperParams),
          this.swiperEl.initialize();
      }

      slidePrev() {
        if (!this.isSwiperReady) return;
        this.swiperInstance.slidePrev();
      }

      slideNext() {
        if (!this.isSwiperReady) return;
        this.swiperInstance.slideNext();
      }
    }
  );
}